import PreviewContainer from './PreviewContainer';
import Loading from '../../Shared/Loading';
import WorkflowEngineHeader from '../../WorkflowEngine/WorkflowEngineHeader';
import { WorkflowEngineConfig } from '../../WorkflowEngine/workflowEngineDictionary';

export default {
  container: <PreviewContainer />,
  loadingView: (
    <>
      <WorkflowEngineHeader />
      <Loading sx={{ marginTop: '70px' }} />
    </>
  )
} as WorkflowEngineConfig;
